define(
    'viewmodels/secured/lists/lists',[
        "viewmodels/ViewModelNotification",
        "providers/dataprovider",
        "extensions/kendo.extensions",
        "i19n!i19n/strings",
        "plugins/router",
        "viewmodels/secured/lists/create",        
        "viewmodels/secured/lists/delete",
        "viewmodels/secured/lists/settings",
        "viewmodels/secured/lists/columns",
        "viewmodels/secured/lists/access"
    ],
    function (ViewModelNotification, dataProvider, kendoExt, i19n, router, createModel, deleteModel, settingsModel, columnsModel, accessControl) {
        var comboBox = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            lists: ko.observable([]),
            selectedList: ko.observable(),
            gridData: {
                list: ko.observable(),
                listResults: ko.observable(),
                refresh: ko.observable(false),
                accessControlShow: {},
                canEditListValues: false,
                isAdmin: false,
                load: ko.observable(false)
            },
            navMenu: {
                navs: ko.observableArray([])
            },
            navAction: ko.observable(),
            isListEmpty: ko.observable(false),
            isAdmin: ko.observable(false),

            $wnd : null,
            wnd : null,         

            accessControl: accessControl
        });
        vm.activate = function () {
            sessionStorage.setItem("view-list-nav-id", "list");

            vm.notifications([]);

            vm.gridData.accessControlShow = function (id) {                
                vm.accessControl
                .loadAccess(id)
                .done(function () {
                    setTimeout(function () {
                        vm.wnd.title(i19n.to.listaccesscontrol);
                        vm.wnd.center().open();
                    }, 500);
                })
                .fail(function (e) {
                    console.error(e);
                });
            }            

            return loadForAccount()
            .done(function () {
                if (comboBox) {
                    var listId = sessionStorage.getItem("view-list-id");
                    var cboVal = comboBox.value();

                    if ((listId != 'null' || listId != null || !!listId)) {
                        vm.selectedList(listId);
                        vm.comboClick(listId);
                        vm.navEditMode();
                    }
                }
            });
        };
        vm.attached = function () {
            var self = this;           

            comboBox = $("#lists").kendoDropDownList({
                dataTextField: "name",
                dataValueField: "listId",
                optionLabel: i19n.to.selectalist,
                dataSource: {
                    transport: {
                        read: function (callbacks) {
                            dataProvider.lists
                            .getLists()
                            .done(function (data) {
                                data = data || [];
                                data = _.sortBy(data, function (itm) { return itm.name.toLowerCase(); });
                                //data = _.where(data, {name : "not-found"});

                                self.isListEmpty(data.length == 0);

                                vm.lists(data);

                                callbacks.success(vm.lists());

                                if (data.length > 0) {
                                    var listId = sessionStorage.getItem("view-list-id");
                                    if (!(listId == 'null' || listId == null || !listId)) {
                                        setTimeout(function () {
                                            vm.selectedList(listId);
                                            vm.comboClick(listId);
                                            vm.navEditMode();
                                        }, 500);
                                    }
                                }
                            });
                        },
                    }
                },
                change: onChange
            }).data("kendoDropDownList");

            self.$wnd = $("#lists-accesscontrol-window");

            self.wnd = self.$wnd.kendoWindow({
                title: i19n.to.editaccesscontrol,
                modal: true,
                visible: false,
                resizable: false,
                width: 1090,
                height: 670
            }).data('kendoWindow');            
        };
        vm.reload = function (selectedValue, donotloadcache, name) {
            if (comboBox) {
                
                comboBox.dataSource.read();
                comboBox.dataItem().set('name', name);

                if (selectedValue !== undefined) {
                    comboBox.text(selectedValue);
                    vm.selectedList(comboBox.dataItem().listId);

                    onChange();
                }
            }
        };
        vm.comboClick = function (id) {
            if (comboBox) {
                if (id === undefined) {
                    vm.navReset();
                    comboBox.select(0);
                } else {
                    comboBox.value(id);
                    onChange();
                }
            }
        };
        vm.navClick = function ($data) {
            if ($data.isDisabled())
                return;

            sessionStorage.setItem("view-list-nav-id", $data.id);

            vm.clearNotifications();

            vm.gridData.list(null);

            if ($data.id == 'create') {
                comboBox.select(0);
                vm.navCreateMode();
            }

            var list = comboBox.dataItem();
            if ($data.id == "list" && !(!list || !list.listId)) {
                vm.navAction(null);

                vm.gridData.list({ listId: list.listId, name: list.name, isReadOnly: list.isReadOnly });

                setTimeout(function () {
                    vm.gridData.load(list.listId);
                }, 100);
                
            } else {
                vm.navAction(getViewModel($data.id));
            }

            $.map(vm.navMenu.navs(), function(itm) {
                if (itm.id == $data.id)
                    itm.isSelected(true);
                else
                    itm.isSelected(false);
            });
        };
        vm.navReset = function () {
            vm.navAction({});

            $.map(vm.navMenu.navs(), function (itm) { itm.isSelected(false);});

            vm.navCreateMode();            
        };
        vm.navCreateMode = function () {
            var self = this;

            if (!self.isAdmin())
                return;

            vm.isListEmpty(false);

            _.find(vm.navMenu.navs(), function (data) { return data.id == "list"; }).isDisabled(true);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "settings"; }).isDisabled(true);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "columns"; }).isDisabled(true);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "delete"; }).isDisabled(true);
        };
        vm.navEditMode = function () {
            var self = this;

            if (!self.isAdmin())
                return;

            _.find(vm.navMenu.navs(), function (data) { return data.id == "list"; }).isDisabled(false);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "settings"; }).isDisabled(false);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "columns"; }).isDisabled(false);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "delete"; }).isDisabled(false);
        };
        vm.close = function() {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };        
        vm.saveAccessControl = function () {
            var self = this;

            self.accessControl.saveClick();
            self.wnd.center().close();
        };        
        vm.closeAccessControl = function () {
            var self = this;

            self.accessControl.cancelClick();
            self.wnd.center().close();
        };

        return vm;

        function loadForAccount() {
            var d = $.Deferred();

            //setTimeout(function () {
            $.when(loadAccountRole(), loadAccountAttributes())
            .done(function (p1, p2) {
                d.resolve();
            })
            .fail(function (e) {
                d.reject(e);
            });
            //}, 10000);

            return d.promise();
        }
        function loadAccountRole() {
            var d = $.Deferred();

            vm.isAdmin(vm.session.role == 3 || vm.session.role == 4 ? true : false);
            vm.gridData.isAdmin = vm.isAdmin();

            if (vm.isAdmin()) {
                vm.navMenu.navs([
                    { id: "create", text: i19n.to.create, isSelected: ko.observable(false), isDisabled: ko.observable(false) },
                    { id: "list", text: i19n.to.list, isSelected: ko.observable(false), isDisabled: ko.observable(true) },                    
                    { id: "settings", text: i19n.to.settings, isSelected: ko.observable(false), isDisabled: ko.observable(true) },
                    { id: "columns", text: i19n.to.columns, isSelected: ko.observable(false), isDisabled: ko.observable(true) },
                    { id: "delete", text: i19n.to.deletelist, isSelected: ko.observable(false), isDisabled: ko.observable(true) }
                ]);
            }

            d.resolve();

            return d.promise();
        }
        function loadAccountAttributes() {
            var d = $.Deferred();

            dataProvider.accounts
            .getAttributes()
            .done(function (data) {
                vm.gridData.canEditListValues = data.canEditListValues;

                d.resolve();
            })
            .fail(function (e) {
                console.log(e);

                d.reject();
            });

            return d.promise();
        }

        function onChange() {
            vm.navReset();

            var list = comboBox.dataItem();

            sessionStorage.removeItem("view-list-id");
            sessionStorage.setItem("view-list-id", list.listId);

            if (!list.listId) {
                vm.gridData.list(null);
                
            } else {
                vm.navEditMode();
                if (!(!sessionStorage.getItem("view-list-nav-id")) && sessionStorage.getItem("view-list-nav-id") == "create") {
                    vm.navClick({ id: "list", isDisabled: function () { return false; } });                    
                } else {
                    vm.navClick({ id: sessionStorage.getItem("view-list-nav-id"), isDisabled: function () { return false; } });
                }
            }

            
        }

        function getViewModel(type) {
            var model = {};

            if (type == 'create') model = createModel;
            if (type == 'delete') model = deleteModel;
            if (type == 'settings') model = settingsModel;
            if (type == 'columns') model = columnsModel;
            if (type == 'delete') {                
                model.name = comboBox.dataItem().name;
            }

            model.id = vm.selectedList();
            model.notify = vm.notify;
            model.reload = vm.reload;
            model.comboClick = vm.comboClick;

            return model;
        }
    }
);
